<template>
  <div>
    <RMSFieldLabel
      v-if="config.showLabel ?? true"
      :fieldId="fieldId"
      :fieldLabel="config.label"
      :config="{ showAvailable: false, showRequired: config.showRequired }"
    />
    <InputText
      :id="fieldId"
      v-model="userText"
      class="inputfield w-full h-[2.65rem]"
      :disabled="disabled"
      :placeholder="config.placeholder ?? undefined"
      :class="!inputIsValid ? 'p-invalid' : ''"
      @input="onInput"
    />
    <span v-if="!inputIsValid" class="text-sm text-red-600">{{ validInputDescription }}</span>
  </div>
</template>
<script>
import { ref } from 'vue'
import RMSFieldLabel from '@/components/fields/RMSFieldLabel.vue'
import InputText from 'primevue/inputtext'

export default {
  name: 'RMSInputText',
  components: {
    RMSFieldLabel,
    InputText,
  },
  props: {
    fieldId: {
      type: String,
      default: 'rms-input-text'
    },
    config: {
      type: Object,
      default: () => {}
    },
    originalValue: {
      type: String,
      default: () => undefined,
    },
    validInputRegEx: {
      type: RegExp,
      default: () => undefined
    },
    validInputDescription: {
      type: String,
      default: () => undefined
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
  },
  emits: ['onValidInput', 'onInvalidInput', 'onClear', 'onBlur'],
  setup(props, { emit }) {
    const userText = ref(props.originalValue)
    const inputIsValid = ref(true)

    const onInput = (event) => {
      if (event.target.value === '') {
        inputIsValid.value = true
        emit('onClear')
        return
      }

      if (props.validInputRegEx) {
        if (props.validInputRegEx.test(event.target.value)) {
          inputIsValid.value = true
          emit('onValidInput', event.target.value)
        } else {
          inputIsValid.value = false
          emit('onInvalidInput', event.target.value)
        }
      } else {
        inputIsValid.value = true
        emit('onValidInput', event.target.value)
      }
    }

    const resetSelected = () => {
      inputIsValid.value = true
      userText.value = props.originalValue
    }

    return {
      userText,
      inputIsValid,
      onInput,
      resetSelected
    }
  },
}
</script>
